export default __webpack_public_path__ + "static/media/LF-1Closed.774ab121.jpg";